import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Redirect} from 'react-router';
import Settings from '../lib/settings';
import {connect} from 'react-redux'
import * as Actions from '../actions';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      auth: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, this.props.menuPosition);
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
    //ReactDOM.findDOMNode(this.refs[event.target.name]).classList.remove(Settings.wrongInput);
  }

  handleSubmit(event) {
    event.preventDefault();
    let errorCheck = true;

    this.setState({formMessage: []});

    if (this.state.email === "" || this.state.password === "") {
      this.addFormMessage("Prosím vyplňte email a heslo.");
      errorCheck = false;
    }

    if (errorCheck) {


      let user = {
        email: this.state.email.trim().toLowerCase(),
        password: this.state.password
      }
        //this.props.dispatch(Actions.loader(true));
        fetch("/api/login", Settings.fetchParams('POST', user)).then(res => {
          this.props.dispatch(Actions.loader(false));
          if (res.ok) {
            res.json().then(json => {
              if (!json.error) {
                if(json.notFound) {
                  alert("Uživatel s tímto emailem neexistuje.");
                } else if(json.wrongPassword) {
                    alert("Nesprávné heslo.");

                } else if(json.ok) {

                  this.props.dispatch(Actions.loginAction(json.user, json.user.role === "admin" ? Settings.adminUserMenu : Settings.userMenu));

                }
              } else {
                alert("Chyba při přihlašování");
              }
            })
          } else {
            alert("Error");
          }
        });


    }

  }

  render() {

    if (this.props.match.params.last) {
      if(this.props.auth) {
        return <Redirect to={"/" + this.props.match.params.last}/>;
      }
    } else {
      if(this.props.auth) {
        return <Redirect to="/"/>;
      }
    }


    return (<div className="form">
      <h1>
        Přihlásit:
      </h1>
      <form onSubmit={this.handleSubmit}>
      <div className="row">
        <div className="col50">
          <div className="formLabel">E-mail</div>
          <div className="formInput"><input type="text" name="email" required="required"  onChange={this.handleChange}/></div>
        </div>
        <div className="col50">
          <div className="formLabel">Heslo</div>
          <div className="formInput"><input type="password" name="password" required="required"  onChange={this.handleChange}/></div>
        </div>
      </div>


      <div className="col100">
        <button type="submit">Přihlásit</button>
      </div>
      </form>
      <div className="col100">
        <p className="registerHere"><Link to="/signup">Nemáte svůj účet? Zaregistrovat se můžete zde.</Link></p>
      </div>
    </div>);
  }
}
function mapStateToProps(state){
  return {
    auth: state.auth,
    menuPosition: state.menuPosition,
  };
}
export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/pages/Login.js